import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscussionWidgetComponent } from './discussion-widget.component';
import { ChatBoxModule } from '../chat-widget/chat-box/chat-box.module';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { CompactVisitorInfoModule } from 'shared/components/compact-visitor-info/compact-visitor-info.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { DiscussionsModule } from 'shared/components/discussions/discussions.module';
import { EmailViewerModule } from 'shared/components/email-viewer/email-viewer.module';
import { PreviewHeaderModule } from 'components/queue-view/queue-view-tab/work-item-preview/preview-header/preview-header.module';

@NgModule({
  imports: [
    CommonModule,
    ChatBoxModule,
    EmailViewerModule,
    WorkWidgetHeaderModule,
    CompactVisitorInfoModule,
    VisitorHistoryModule,
    DiscussionsModule,
    PreviewHeaderModule
  ],
  declarations: [
    DiscussionWidgetComponent
  ],
  exports: [
    DiscussionWidgetComponent
  ]
})
export class DiscussionWidgetModule {}
